import { Component, Input } from "@angular/core";
import { config } from "@config";
import { OnfidoService } from "../../services/onfido.service";

@Component({
	selector: "verification-browser-modal",
	templateUrl: "./verification-browser-modal.component.html",
	styleUrls: ["./verification-browser-modal.component.scss"],
	standalone: false
})
export class VerificationBrowserModalComponent {
	@Input() public incompatibilityType: string = OnfidoService.chromeApps; // Show Chrome and Apps message;

	public showChromeAppsMessage(): boolean {
		return this.incompatibilityType === OnfidoService.chromeApps;
	}

	public showSafariMessage(): boolean {
		return this.incompatibilityType === OnfidoService.iosApp;
	}

	public getGooglePlayDownloadLink(): string {
		return config.externalPaths["mobileApps"]["androidUrl"];
	}

	public getAppStoreDownloadLink(): string {
		return config.externalPaths["mobileApps"]["iosUrl"];
	}
}
